exports.noCodeCaseStudies = [
    {
      id: "one",
      title: "Mindfull Eating",
      slug: "mindfull-eating",
      heroTitle: "Mindfull Eating",
      heroSubtitle: "Building a strong personal brand through consistent and engaging content.",
      logo: "/img/no-code-case-studies/logo/mindful.png",
      about: "A certified lifestyle dietician and nutritionist specializing in mindful eating and therapeutic diets. Successfully treated 1,000+ clients with sustainable plans.",
      challenges: [
        "On time quality content and reel creation.",
        "Consistent posting."
      ],
      goals: [
        "Increase reach and followers.",
        "Have viral content.",
        "Reach the right audience.",
        "Establish a strong personal brand."
      ],
      solution: [
        "Established a unique personal brand.",
        "Content scheduling based on engagement."
      ],
      implementation: [
        "Daily reels with weekly stories.",
        "Aligned marketer, creative head, and editor."
      ],
      results: [
        "Instagram followers reached 14K.",
        "Average reel views reached 4K.",
        "Multiple viral reels with million+ views."
      ]
    },
  
    {
      id: "two",
      title: "Oner",
      slug: "oner",
      logo: "/img/no-code-case-studies/logo/oner.png",
      about:
        "ONER is an international fashion brand founded in 1997, focused on effortless style, sustainability, and durable quality.",
      challenges: [
        "Highly saturated e-commerce fashion market."
      ],
      goals: [
        "Increase website traffic.",
        "Boost social engagement."
      ],
      solution: [
        "Instagram-first strategy.",
        "Email marketing campaigns."
      ],
      implementation: [
        "Optimized product pages.",
        "Launched Meta Ads."
      ],
      results: [
        "50% organic traffic growth in 3 months.",
        "Conversion rate doubled from 1.5% to 3%."
      ]
    }
  ];
  